import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { fetchApiData } from "../../../redux/reducers/commonApiSlice";
import { user_get, usersGetKey, userUpdate } from "../../../data/ApiEndpoints";
import { registerUser } from "../../../redux/reducers/postApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { validatemap_form_email } from "../../../exports/Validations";
import SelectDropdown from "../../components-react/SelectDropdown";
import { gender } from "../../common-data/DropdowData";
import {
  convertToYYYYMMDD,
  currentMonthCurrentDate,
} from "../../common-data/Converts";
import Loader from "../../ui/Loader";
import { useUpdateForm } from "../../../data/Queries";

const VerifyRegisterMember = ({
  isFromMembershipTransfer = false,
  userInfoData,
  formValues,
  setFormValues,
  formErrors,
  setFormErrors,
  isMemberVerified,
  setIsMemberVerified,
  assignRef,
}) => {
  const dispatch = useDispatch();
  const { loading, data: commonGetData } = useSelector((state) => state.common);
  const { mutateAsync: updateUser } = useUpdateForm({
    url: userUpdate,
    key: usersGetKey,
    token: userInfoData?.token,
  });

  const [isUserExist, setIsUserExist] = useState(false);
  const [isUpdateRequired, setIsUpdateRequired] = useState(null);
  const [isFetchUserDetaillsByMobile, setIsFetchUserDetaillsByMobile] =
    useState(false);

  function getUserDetails(filters) {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: user_get,
        payload: {
          filters: filters,
        },
        token: userInfoData?.token,
      })
    );
  }

  const handleRegisterUser = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(registerUser({ userData, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status && result?.payload?.data) {
        const { name, email, gender, dob } = result?.payload?.data;

        console.log("result.payload.data=> ", result.payload.data);

        setFormValues((prevs) => ({
          ...prevs,
          memberName2: name,
          memberEmail2: email,
          memberGender2: gender ? { label: gender, value: gender } : "",
          memberDOB2: dob ? convertToYYYYMMDD(dob) : prevs.memberDOB2 || "",
          member2Info: result.payload.data,
        }));

        setIsMemberVerified(true);
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleRegisterUser ERROR => ", error);
    }
  };

  const validateForm = (formValues) => {
    let errors = {};
    const isCouple = formValues.selectedPlan?.is_couple ? true : false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const nameRegex = /^[A-Za-z\s]+$/;
    const yopmailRegex = /@yopmail\.com$/i;
    const mobileRegex = /^\d{10}$/;

    const today = moment().tz("Asia/Kolkata").startOf("day");

    if (isCouple || isFromMembershipTransfer) {
      if (
        !formValues.memberMobile2 ||
        !mobileRegex.test(formValues.memberMobile2)
      ) {
        errors.memberMobile2 = "Mobile number must be 10 digits!";
      } else if (formValues.memberMobile === formValues.memberMobile2) {
        errors.memberMobile2 = "Customer mobile number must be different!";
      }

      if (!formValues.memberName2 || !nameRegex.test(formValues.memberName2)) {
        errors.memberName2 = "Name should only contain letters!";
      }

      if (
        !formValues.memberEmail2 ||
        !emailRegex.test(formValues.memberEmail2)
      ) {
        errors.memberEmail2 = "Enter a valid email!";
      } else if (yopmailRegex.test(formValues.memberEmail2)) {
        errors.memberEmail2 = "Yopmail is not allowed!";
      }

      if (!formValues.memberGender2) {
        errors.memberGender2 = "Required!";
      }

      if (!formValues.memberDOB2) {
        errors.memberDOB2 = "Required!";
      } else if (formValues.memberDOB2) {
        const enteredDOB2 = moment
          .tz(formValues.memberDOB2, "Asia/Kolkata")
          .startOf("day");

        const age = today.diff(enteredDOB2, "years");

        if (enteredDOB2.isAfter(today)) {
          errors.memberDOB2 = "DOB cannot be in the future!";
        } else if (age < 10) {
          errors.memberDOB2 = "Member must be at least 10 years old!";
        }
      }
    }

    return errors;
  };

  const validateForm1 = (formValues) => {
    let errors = {};
    const isCouple = formValues.selectedPlan?.is_couple ? true : false;
    const mobileRegex = /^\d{10}$/;

    if (isCouple || isFromMembershipTransfer) {
      if (
        !formValues.memberMobile2 ||
        !mobileRegex.test(formValues.memberMobile2)
      ) {
        errors.memberMobile2 = "Mobile number must be 10 digits!";
      } else if (formValues.memberMobile === formValues.memberMobile2) {
        errors.memberMobile2 = "Customer mobile numbers must be different!";
      }
    }

    return errors;
  };

  async function handleUpdateUser(userData) {
    try {
      const formdata = new FormData();

      Object.entries(userData).forEach(([key, value]) => {
        formdata.append(key, value);
      });

      const { status, message, data } = await updateUser({ data: formdata });

      console.log("data=> ", data);

      if (status) {
        const { name, email, gender, dob } = data[0];

        toast.success(message);
        setFormValues((prevs) => ({
          ...prevs,
          memberName2: name,
          memberEmail2: email,
          memberGender2: gender ? { label: gender, value: gender } : "",
          memberDOB2: dob ? convertToYYYYMMDD(dob) : prevs.memberDOB2 || "",
          member2Info: data[0],
        }));

        setIsUserExist(false);
        setIsUpdateRequired(null);
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const onClickRegisterUser = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        uid: isUpdateRequired ? formValues.member2Info?.uid : "",
        name: formValues.memberName2,
        mobile: formValues.memberMobile2,
        email: formValues?.memberEmail2,
        gender: formValues.memberGender2?.value,
        dob: formValues.memberDOB2 || "",

        is_web: 1,
        account_type: "member",
        otp: "otp",
        referral_code: "",
        n_token: "n_token",
      };

      if (isUpdateRequired) {
        handleUpdateUser(userData);
      } else {
        handleRegisterUser(userData, userInfoData?.token);
      }
    }
  };

  const onClickFetchUserDetails = () => {
    const errors = validateForm1(formValues);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const handleConfirm = () => {
        const filters = {
          mobile: formValues.memberMobile2,
        };

        getUserDetails(filters);

        setIsFetchUserDetaillsByMobile(true);
      };

      showConfirmAlert(
        handleConfirm,
        `Is the entered ${formValues.memberMobile2} number correct?`
      );
    }
  };

  function handleBack() {
    setFormValues((prevs) => ({
      ...prevs,
      memberMobile2: "",
      memberName2: "",
      memberEmail2: "",
      memberGender2: "",
      memberDOB2: "",
      member2Info: "",
    }));
    setIsUserExist(false);
    setIsFetchUserDetaillsByMobile(false);
    setIsMemberVerified(false);
    setIsUpdateRequired(null);
  }

  useEffect(() => {
    if (
      isFromMembershipTransfer &&
      isFetchUserDetaillsByMobile &&
      commonGetData?.status
    ) {
      toast.error(
        "Membership transfer is not applicable for any existing WTF member. It is only applicable for members who have not had any membership previously."
      );
    } else if (
      !isFromMembershipTransfer &&
      isFetchUserDetaillsByMobile &&
      commonGetData?.status
    ) {
      const { email, gender, name, dob, account_type } =
        commonGetData?.data?.[0];

      const memberMemberExist = commonGetData?.data?.length > 0;
      const isEmailInvalid = !validatemap_form_email(email);
      const isGenderMissing = !gender;

      if (memberMemberExist && account_type !== "member") {
        toast.error(
          `This mobile number is already registered with a different account type ${account_type?.replace(
            /_/g,
            " "
          )}!`
        );
        return;
      } else if (isEmailInvalid || isGenderMissing) {
        setIsUpdateRequired({
          isEmailRequired: !validatemap_form_email(email) ? email : false,
          isGenderRequired: !gender ? true : false,
        });

        setFormValues((prevs) => ({
          ...prevs,
          memberName2: name,
          memberEmail2: email,
          memberGender2: gender ? { label: gender, value: gender } : "",
          memberDOB2: dob ? convertToYYYYMMDD(dob) : prevs.memberDOB2 || "",
          member2Info: commonGetData?.data?.[0],
        }));

        let errorMessage = "Please update the following fields: ";
        if (isEmailInvalid) errorMessage += "Email ";
        if (isEmailInvalid && isGenderMissing) errorMessage += "and ";
        if (isGenderMissing) errorMessage += "Gender.";

        toast.error(errorMessage);
      } else {
        setFormValues((prevs) => ({
          ...prevs,
          memberName2: name,
          memberEmail2: email,
          memberGender2: gender ? { label: gender, value: gender } : "",
          memberDOB2: dob ? convertToYYYYMMDD(dob) : prevs.memberDOB2 || "",
          member2Info: commonGetData?.data?.[0],
        }));
        setIsUserExist(false);
        setIsMemberVerified(true);
        setIsUpdateRequired(null);
      }
    } else if (isFetchUserDetaillsByMobile && commonGetData?.status === false) {
      setIsUserExist(true);
      toast.error(commonGetData?.message);
    }
  }, [commonGetData]);

  console.log("formErrors=> ", formErrors);

  return (
    <>
      {isUserExist || isMemberVerified || isUpdateRequired ? (
        <>
          <div className="formInputBox">
            <label htmlFor="memberMobile2" className="formInputLabel">
              second member Mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              name="memberMobile2"
              ref={assignRef("memberMobile2")}
              className="formInput"
              placeholder={`🚫 ${formValues?.memberMobile2 || "NA"}`}
              disabled
            />

            <span className="error-label">
              {formErrors?.memberMobile2 || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberName2" className="formInputLabel">
              second member Name <span className="required">*</span>
            </label>

            <input
              type="text"
              name="memberName2"
              ref={assignRef("memberName2")}
              className={`formInput ${
                formErrors.memberName2 ? "formError" : ""
              }`}
              placeholder="Enter Name"
              value={formValues.memberName2}
              onChange={(e) =>
                setFormValues({ ...formValues, memberName2: e.target.value })
              }
              disabled={isMemberVerified}
            />

            <span className="error-label">{formErrors?.memberName2 || ""}</span>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberEmail2" className="formInputLabel">
              second member Email <span className="required">*</span>
            </label>

            <input
              type="email"
              name="memberEmail2"
              ref={assignRef("memberEmail2")}
              className={`formInput ${
                formErrors.memberEmail2 ? "formError" : ""
              }`}
              style={{ textTransform: "lowercase" }}
              placeholder="Enter Email"
              value={formValues.memberEmail2}
              onChange={(e) =>
                setFormValues({ ...formValues, memberEmail2: e.target.value })
              }
              disabled={isMemberVerified}
            />

            <span className="error-label">
              {formErrors?.memberEmail2 || ""}
            </span>
          </div>

          <div className="formInputBox">
            <label htmlFor="memberGender2" className="formInputLabel">
              second member gender <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.memberGender2 ? "formError" : ""
              } ${isMemberVerified ? "disabled" : ""}`}
              ref={assignRef("memberGender2")}
              style={{ border: isMemberVerified ? "none" : "" }}>
              <SelectDropdown
                options={gender.slice(0, -1)}
                selectedOption={formValues.memberGender2}
                setSelectedOption={(selectedValue) =>
                  setFormValues({
                    ...formValues,
                    memberGender2: selectedValue,
                  })
                }
                name="gender"
                isDisable={isMemberVerified}
              />
            </div>

            <span className="error-label">
              {formErrors?.memberGender2 || ""}
            </span>
          </div>

          <div className="formInputBox span2">
            <label htmlFor="memberDOB2" className="formInputLabel">
              second member DOB <span className="required">*</span>
            </label>

            <div className="input-add-btn flexBetween">
              <input
                type="date"
                name="memberDOB2"
                ref={assignRef("memberDOB2")}
                className={`formInput ${
                  formErrors.memberDOB2 ? "formError" : ""
                } ${formValues.memberDOB2 ? "date-has-value" : ""}`}
                value={formValues.memberDOB2}
                onChange={(e) =>
                  setFormValues({ ...formValues, memberDOB2: e.target.value })
                }
                max={currentMonthCurrentDate}
                disabled={isMemberVerified}
              />

              <button
                type="button"
                className="btn btn-dark extraBtn"
                style={{
                  minWidth: "150px",
                  height: "60px",
                  textTransform: "capitalize",

                  background: isMemberVerified ? "#00712d" : "#b40b0b",
                  border: isMemberVerified
                    ? "1px solid #00712d"
                    : "1px solid #b40b0b",
                  cursor: isMemberVerified ? "not-allowed" : "pointer",
                }}
                onClick={
                  isMemberVerified
                    ? null
                    : () => onClickRegisterUser(isUpdateRequired ? true : false)
                }
                disabled={isMemberVerified}>
                {loading ? (
                  <Loader />
                ) : isMemberVerified ? (
                  "verified"
                ) : isUpdateRequired ? (
                  "Update Details"
                ) : (
                  "Register"
                )}
              </button>

              <button
                type="button"
                className="btn btn-dark extraBtn"
                style={{
                  minWidth: "150px",
                  height: "60px",
                  textTransform: "capitalize",
                }}
                onClick={handleBack}>
                Clear
              </button>
            </div>

            <span className="error-label">{formErrors?.memberDOB2 || ""}</span>
          </div>
        </>
      ) : (
        <div className="formInputBox span2">
          <label htmlFor="memberMobile2" className="formInputLabel">
            second member mobile <span className="required">*</span>
          </label>

          <div className="input-add-btn flexBetween">
            <input
              type="number"
              name="memberMobile2"
              ref={assignRef("memberMobile2")}
              className={`formInput ${
                formErrors.memberMobile2 ? "formError" : ""
              }`}
              placeholder="Enter Mobile Number"
              value={formValues.memberMobile2}
              onChange={(e) => {
                const mobileValue = e.target.value;

                if (mobileValue.length <= 10) {
                  setFormValues((prevs) => ({
                    ...prevs,
                    memberMobile2: mobileValue,
                    memberName2: "",
                    memberEmail2: "",
                    memberGender2: "",
                    memberDOB2: "",
                    member2Info: "",
                  }));
                }

                setIsMemberVerified(false);
              }}
            />

            <button
              type="button"
              className="btn btn-dark extraBtn"
              style={{
                minWidth: "150px",
                height: "60px",
                textTransform: "capitalize",
                background: isMemberVerified ? "#00712d" : "#000",
                border: isMemberVerified
                  ? "1px solid #00712d"
                  : "1px solid #000",
                cursor: isMemberVerified ? "not-allowed" : "pointer",
              }}
              onClick={isMemberVerified ? null : onClickFetchUserDetails}
              disabled={isMemberVerified}>
              {loading ? <Loader /> : isMemberVerified ? "verified" : "verify"}
            </button>
          </div>

          <span className="error-label">{formErrors.memberMobile2 || ""}</span>
        </div>
      )}
    </>
  );
};

export default VerifyRegisterMember;
